export const EXHIBITIONS = [
  {
    slug: "descendants-of-the-sun",
    label: "Upcoming exhibition",
    title: "Descendants of",
    subtitle: "the Sun",
    date: "November 7, 2026",
    time: "4 to 8 pm",
    flyerUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/tibt0uim_Love%20Quetee%20Solo%20Exhibition%20%283%29.png",
    venue: "African Museum, Arts and Culture Center / Saint Paul, Minnesota",
    status: "Upcoming exhibition",
    description: "Descendants of the Sun examines the relationship between land, nature, community, and lineage through a West African and Liberian perspective.\n\nIn many West African communities, daily life is closely connected to the outdoors through work, play, gathering, and celebration. This connection creates a relationship between the sun, the body, and the land, allowing me to consider Blackness in relation to the natural world. Rather than treating the landscape as a background, I view it as part of the narrative and a reflection of the people who inhabit it.\n\nI am interested in the stories that exist between what is remembered and what was not personally experienced. Stories my mother shared about her childhood provide a way for me to engage with a history that I inherited but did not directly witness. Descendants of the Sun allows me to interpret these stories and consider how they continue to influence my understanding of home.",
    gallery: [],
  },
  {
    slug: "minnesota-state-fair",
    label: "Past exhibition",
    title: "Minnesota State Fair",
    subtitle: "Fine Art Exhibition",
    date: "Aug 27 – Sept 7, 2026",
    venue: "Minnesota State Fair",
    status: "Past exhibition",
    description: "View Gbanganla at the Minnesota Museum of American Art as part of its permanent collection.",
    gallery: [
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/dy7zzs6m_Screenshot_20260902_191011_Gallery.jpg",
        alt: "Portrait installation view of Love Quetee at the Minnesota State Fair",
        caption: "Installation view / Minnesota State Fair",
        type: "Installation view",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/w044rsrx_Screenshot_20260902_191107_Gallery.jpg",
        alt: "Visitors standing beside a large framed painting at the Minnesota State Fair",
        caption: "Installation view / visitors with the work",
        type: "Installation view",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/i6uqg0n9_Screenshot_20260902_191119_Gallery.jpg",
        alt: "Visitors viewing a large portrait painting in the Minnesota State Fair gallery",
        caption: "Installation view / gallery room",
        type: "Installation view",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/888o263d_Screenshot_20260902_191225_Instagram.jpg",
        alt: "Framed portrait painting with exhibition labels at the Minnesota State Fair",
        caption: "Artwork view / Minnesota State Fair",
        type: "Artwork view",
      },
    ],
  },
  {
    slug: "ghetto-visionary",
    label: "Past exhibition",
    title: "Ghetto Visionary",
    subtitle: "",
    date: "November 10, 2023",
    venue: "The 410 Project / Mankato, Minnesota",
    status: "Past exhibition",
    description: "Ghetto Visionary was a show about celebrating Black and ghetto culture. Ghettos were communities created to house low-class, low-income people and minorities. Because of that, the word ghetto was often used as a degrading term, usually meaning tasteless or classless. I wanted to show that being ghetto was not a negative thing, but rather that it was fashionable, innovative, and creative. It was about taking something negative, turning it into a positive, and making it a way of life. I wanted to show that Black culture was beautiful in all aspects. To be ghetto is to be a visionary.",
    gallery: [
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/t4e0m6q2_Love%20Quetee%20Defying%20Gravity_140518.webp",
        alt: "Artwork detail with a figure's afro adorned by brightly colored combs",
        caption: "Artwork detail / Defying Gravity",
        type: "Artwork detail",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/ilj81qy9_20231221_140711.webp",
        alt: "Circular artwork detail showing a hair clip spelling GHETTO",
        caption: "Artwork detail / Ghetto hair clip",
        type: "Artwork detail",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/qxc6mbbw_20231221_141215.webp",
        alt: "Circular mixed-media artwork with gold jewelry and display cards",
        caption: "Artwork detail / gold jewelry and text",
        type: "Artwork detail",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/jncomndd_20231221_140130.webp",
        alt: "Circular artwork of a bird on a wire with shoes hanging below",
        caption: "Artwork detail / bird and shoes",
        type: "Artwork detail",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/coz03gst_Screenshot_20260902_185951_Instagram.jpg",
        alt: "Portrait installation view of visitors looking at Ghetto Visionary artworks",
        caption: "Installation view / Ghetto Visionary",
        type: "Installation view",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/zr6qvk6o_Screenshot_20260902_190012_Instagram.jpg",
        alt: "Landscape installation view of visitors and artworks on a bright blue gallery wall",
        caption: "Installation view / gallery wall",
        type: "Installation view",
      },
      {
        url: "https://customer-assets-39nsmqrw.emergentagent.net/job_dark-canvas-47/artifacts/8s7p4z9v_Screenshot_20260902_190120_Instagram.jpg",
        alt: "Installation view of a circular blue artwork with a visitor in the gallery",
        caption: "Installation view / blue wall",
        type: "Installation view",
      },
    ],
  },
];
